import React from "react"
import SectionHero from "../components/SectionHero"
import ListTour from "../components/ListTour"
import { graphql, useStaticQuery } from "gatsby"
import { Element, Link } from "react-scroll"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Footer from "../components/Footer"
import Header from "../components/header"
import AboutSection from "../components/AboutSection"
import Featured from "../components/Featured"
// import { Helmet } from "react-helmet"
import Img from "gatsby-image"
import { StaticImage } from "gatsby-plugin-image"

const IndexPage = () => {

  // const imageLeft = data.imgLeft.childImageSharp.fluid

  const { allMarkdownRemark } = useStaticQuery(
    graphql`
    query {

      site {
        siteMetadata {
          title
          
        }
      }
  allMarkdownRemark(filter: { frontmatter: { key: { eq: "wisata" } } }, sort: {fields: frontmatter___title, order: ASC}) {
    edges {
      node {
        fields{
          slug
        }
        frontmatter {
          title
          url
          alamat
          thumbnailImage {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        html
      }
    }
  }
}
    `
  )


  return (


    <Layout>


      <SEO
        title="Koramil Virtual Tour"
        description="Jelajahi Sumedang - Virtual Tourism"
        lang="id"
      />

      <Header className={`bg-transparent absolute top-0 left-0 w-full z-50`} />


      <Element name="section-one">
        <SectionHero className="my-12">
          {/* <h5 className="text-lg text-gray-50">Selamat Datang di</h5> */}

          <div className="mx-auto w-full px-8 py-16 sm:py-32 lg:py-8">

            <h1 className="font-bold text-right sm:text-6xl text-3xl text-gray-100 mt-4 tracking-tighter sm:tracking-normal">
              Bersama menjaga kedaulatan, <br />
              bersama menumbuhkan kemakmuran.

              

              
            </h1>
            <div className="float-right ">
              <Link
                activeclassName="active"
                to="section-two"
                spy={true}
                smooth={true}
                duration={1000}
                className="inline-flex cursor-pointer mx-auto bg-yellow-400 text-gray-800 font-bold rounded-full my-6 py-4 px-6 shadow-lg focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out mt-10 gap-2">
                Mulai Jelajahi
                <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.1344 10.8174L13.4998 16.1827L18.8652 10.8174" stroke="#01392A" stroke-width="1.78846" stroke-linecap="round" stroke-linejoin="round" />
                  <rect x="0.692308" y="-0.692308" width="25.6154" height="25.6154" rx="12.8077" transform="matrix(1 0 0 -1 0 25.6154)" stroke="#01392A" stroke-width="1.38462" />
                </svg>
              </Link>
            </div>
            {/* <Img className="rounded-lg shadow-xl ring-1 ring-black ring-opacity-5" src="https://tailwindui.com/img/component-images/top-nav-with-multi-column-layout-screenshot.jpg" alt=""/> */}

          </div>


          <div className="lg:px-8 px-8">
            <div className="flex flex-start">
              <div className="border-l-2 border-white py-2 sm:px-8 px-4 sm:max-w-xl text-sm text-gray-50">
                Website Virtual Tour Kodim 0610 Sumedang menyajikan pengalaman virtual tour interaktif untuk melihat fasilitas dan aktivitas militer dari berbagai sudut pandang.
              </div>
            </div>
          </div>
        </SectionHero>
      </Element>



     
      <AboutSection className={`bg-transparent absolute top-0 left-0 w-full z-50`} />


      {/* <Element>
        <Featured/>

      </Element> */}


      <Element name="section-two">
        <section className="bg-white py-8">
          <div className="container mx-auto flex flex-wrap pt-4 pb-12">
            {/* <h1 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">
              Title
            </h1> */}
            <div className="w-full mb-4">
              <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
            </div>

            <div className="container my-12 mx-auto px-4 md:px-12">
              <h2 className="text-3xl font-bold text-center tracking-tight text-green-900 sm:text-3xl mb-8">
                {/* Daftar Komando Rayon Militer */}
                Virtual Tour
              </h2>
              <ListTour tours={allMarkdownRemark.edges} />
            </div>

          </div>
        </section>

      </Element>
      <Footer />


    </Layout>

  )



}


export default IndexPage